import CalendarViewComponent from "./CalendarViewComponent";

const StaffCalendarComponent = () => {
  return (
    <div className="w-full min-w-0 rounded-md bg-white px-2 sm:px-3">
      <CalendarViewComponent />
    </div>
  );
};
export default StaffCalendarComponent;
